export default {"src":"/_next/static/media/icon-calculator.5675462c.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};